
/**
 * console.log shorthand
 *
 * @param Mixed attr
 */
window.cl = function (...attr) {
    if (window.console && console.log) {
        console.log(...attr);
    }
};
window.dd = cl;

/**
 * js equivalent of Laravel's url() helper
 * converts slug to full url
 *
 * @param String str
 * @returns String url
 */
window.url = function (str) {
    if (str.indexOf('http') === 0) return str;

    var charlist = "[ \\s\u00A0/]+";
    var rexp = new RegExp("^(" + charlist + ")|(" + charlist + ")$", "g");
    var base = (App.base + "").replace(rexp, "");
    var slug = (str + "").replace(rexp, "");

    return base + "/" + slug;
};
